/*

FILE: videos.js
DESCRIPTION: Vimeo embeds
AUTHOR(S): R.J. LaCount

*/

import Player from '@vimeo/player';

const initVideos = (els) => {

	const playVideo = (video) => {
		video.play();
	}

	els.forEach(el => {
		const url = el.dataset.url;
		const options = {
			url: url,
			background: true
		}
		const player = new Player(el, options);

		player.on('loadeddata', () => {
			el.classList.add('loaded');
			playVideo(player);
		});
	});
}

export { initVideos }
